import * as React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFacebook, faTwitter, faInstagram, faPinterest} from '@fortawesome/free-brands-svg-icons'
import {graphql, useStaticQuery} from 'gatsby'
import logo from '../images/plant on circle.svg'
import '../styles/footer.scss'

const Footer = () => {
    const data = useStaticQuery(graphql`
        query footerMenu {
            wpMenu(name: {eq: "Footer"}) {
                menuItems {
                    nodes {
                        label
                        url
                    }
                }
            }
        }
    `)

    return (
        <footer className="footer container">
            <div className="footer__content">
                <div className="footer__content__copyright">
                    <img src={logo} alt="Bible to Life Logo"/>
                    <div className="footer__content__copyright__text">
                        <p><strong>Bible to Life</strong> is a ministry of <a rel="noreferrer" target="_blank"
                                                                              href="https://www.moodypublishers.com">Moody
                            Publishers</a>. &copy; {new Date().getFullYear()}.</p>
                        <p>All Rights Reserved. Site by <a href="https://mereagency.com" rel="noreferrer"
                                                           target="_blank">Mere</a>.</p>
                    </div>
                </div>
                <ul className="footer__content__menu">
                    <li>
                        <a href="https://www.facebook.com/BibletoLife" rel="noreferrer" target="_blank">
                            <FontAwesomeIcon icon={faFacebook} size="lg"/>
                        </a>
                    </li>
                    <li>
                        <a href="https://twitter.com/BibleToLife" rel="noreferrer" target="_blank">
                            <FontAwesomeIcon icon={faTwitter} size="lg"/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/bible_to_life/" rel="noreferrer" target="_blank">
                            <FontAwesomeIcon icon={faInstagram} size="lg"/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.pinterest.com/bibletolife/_saved/" rel="noreferrer" target="_blank">
                            <FontAwesomeIcon icon={faPinterest} size="lg"/>
                        </a>
                    </li>
                    {data?.wpMenu.menuItems.nodes.map((item, index) =>
                        <li key={index}>
                            <a href={item.url}>{item.label}</a>
                        </li>
                    )}
                </ul>
            </div>
        </footer>
    )
}

export default Footer
